import AuthService from "../../utilities/services/auth.service";

import { AttendanceSummaryWrapper } from "../../components";

export default function AttendanceSummaryPage() {
  const organization = AuthService.getOrg()[0];

  return <AttendanceSummaryWrapper organizationUUID={organization?.uuid} />;
}
